<template>
    <modal-live>
        <div class="dialog">
            <h2 class="headline--welcome text-center">
                We need to make sure that HAMMER<br />is used
                exclusively by truckers
            </h2>
            <div>
                <div class="d-flex" style="padding-bottom: 30px">
                    <div class="flex-fill">
                        <input-text
                            class="input--high"
                            v-model="first_name"
                            name="first_name"
                            :placeholder="'First name'"
                            :required="true"
                        ></input-text>
                    </div>
                    <div style="min-width: 18px"></div>
                    <div class="flex-fill">
                        <input-text
                            class="input--high"
                            v-model="last_name"
                            name="last_name"
                            :placeholder="'Last name'"
                            :required="true"
                        ></input-text>
                    </div>
                </div>
                <div class="d-flex" style="padding-bottom: 30px">
                    <div class="flex-fill">
                        <input-text
                            class="input--high"
                            v-model="email"
                            name="email"
                            :placeholder="'Email'"
                            :required="true"
                        ></input-text>
                    </div>
                </div>
                <div class="d-flex" style="padding-bottom: 30px">
                    <div class="flex-fill">
                        <input-text
                            class="input--high"
                            v-model="phone"
                            name="phone"
                            :placeholder="'Phone Number'"
                            :required="true"
                        ></input-text>
                    </div>
                    <div style="min-width: 18px"></div>
                    <div class="flex-fill">
                        <input-text
                            class="input--high"
                            v-model="zip"
                            name="zip"
                            :placeholder="'Zip Code'"
                            :required="true"
                        ></input-text>
                    </div>
                </div>
            </div>
            <div v-if="error.show">
                <div class="error__wrapper alert alert-danger text-center">
                    <strong>{{ error.msg }}</strong>
                </div>
            </div>
            <div class="text-center pt-3">
                <Button
                    @click.native="goTo('preferences-for-user')"
                    class="text-sm btn-block"
                    :disabled="isDisabled"
                >
                    Next
                </Button>
            </div>
            <div class="text-center">
                <Bullets :step="step" :steps="steps"></Bullets>
            </div>
        </div>
    </modal-live>
</template>

<script>
export default {
    computed: {
        isDisabled() {
            return !this.isValid;
        },
        isValid() {
            /* eslint-disable */
            return (
                this.first_name &&
                this.last_name &&
                this.email &&
                this.phone &&
                this.zip
            );
            /* eslint-enable */
        },
    },
    data() {
        return {
            icons: window.here.icons,
            step: 1,
            steps: 5,
            first_name: null,
            last_name: null,
            email: null,
            phone: null,
            zip: null,
            error: {
                show: false,
                msg: '',
            },
        };
    },
    methods: {
        goTo(name) {
            this.error = {
                show: false,
                msg: '',
            };

            axios
                .post('/api/v1/profile/save', {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    phone: this.phone,
                    zip: this.zip,
                })
                .then(({ data }) => {
                    if (data.profile.guid) {
                        this.$router.push({
                            name,
                            params: { guid: data.profile.guid },
                        });
                    }
                })
                .catch(({ response }) => {
                    const {
                        data: { errors },
                    } = response;
                    if (errors) {
                        let errorMsg = '';
                        Object.keys(errors).forEach((key) => {
                            const inputWrapper = document.querySelector(
                                `[name="${key}"] .input-text__wrapper`,
                            );
                            inputWrapper.classList.add('error', 'shake');
                            setTimeout(() => {
                                inputWrapper.classList.remove('shake');
                            }, 820);
                            errorMsg += `${errors[key][0]}\n`;
                        });
                        this.error = {
                            show: true,
                            msg: errorMsg,
                        };
                    } else {
                        this.error = {
                            show: true,
                            msg: 'Something went wrong. Try again',
                        };
                    }
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.error__wrapper {
    strong {
        white-space: break-spaces;
    }
}
</style>
